import { fork, all } from 'redux-saga/effects';

import * as user from './user';

export default function* rootSaga() {
  yield all([...Object.values(user)].map(fork));
}
